export const green = {
  100: 'var(--bfc-v2-color-green-100, #dcfff1)',
  200: 'var(--bfc-v2-color-green-200, #baf3db)',
  300: 'var(--bfc-v2-color-green-300, #7ee2b8)',
  400: 'var(--bfc-v2-color-green-400, #4bce97)',
  500: 'var(--bfc-v2-color-green-500, #2abb7f)',
  600: 'var(--bfc-v2-color-green-600, #22a06b)',
  700: 'var(--bfc-v2-color-green-700, #1f845a)',
  800: 'var(--bfc-v2-color-green-800, #216e4e)',
  900: 'var(--bfc-v2-color-green-900, #164b35)',
  1000: 'var(--bfc-v2-color-green-1000, #1c3329)',
  DEFAULT: 'var(--bfc-v2-color-green-700, #1f845a)', // 700
};
